import React from 'react';
import { Btn } from '../Btn/Btn.jsx';
import { Field } from '../Field/Field.jsx';
import { Icon } from '../Icon/Icon.jsx';
import { Input } from '../Input/Input.jsx';
import { Modal } from '../Modal/Modal.jsx';

const h = React.createElement;

const I = (name, size, extra) => h(Icon, { name, size, ...(extra || {}) });

/**
 * Destructive-action dialog.
 *
 * @param {object} p
 * @param {boolean} p.open
 * @param {React.ReactNode} p.title
 * @param {React.ReactNode} [p.body]
 * @param {string} [p.confirmLabel]
 * @param {string} [p.cancelLabel]
 * @param {boolean} [p.danger]
 * @param {string} [p.typeToConfirm]
 * @param {() => void} p.onConfirm
 * @param {() => void} p.onCancel
 * @param {boolean} [p.busy]
 */
export function Confirm({ open, title, body, confirmLabel = 'Delete', cancelLabel = 'Cancel', danger = true, typeToConfirm, onConfirm, onCancel, busy }) {
  const [txt, setTxt] = React.useState('');
  React.useEffect(() => { if (!open) setTxt(''); }, [open]);
  if (!open) return null;
  const ok = !typeToConfirm || txt.trim() === typeToConfirm;
  return h(Modal, { title, onClose: onCancel, width: 460, icon: I(danger ? 'triangle-alert' : 'info', 20), iconTone: danger ? 'coral' : 'gold',
    footer: h(React.Fragment, null, h(Btn, { danger, solid: !danger, disabled: !ok, loading: busy, onClick: onConfirm }, confirmLabel), h(Btn, { ghost: true, onClick: onCancel, 'data-autofocus': true }, cancelLabel)) },
    body ? h('div', { style: { fontSize: 13.5, lineHeight: 1.55, color: 'var(--tx2)' } }, body) : null,
    typeToConfirm ? h(Field, { label: 'Type the name to confirm', hint: typeToConfirm }, h(Input, { value: txt, onChange: (e) => setTxt(e.target.value), placeholder: typeToConfirm, 'data-autofocus': true })) : null);
}
